/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { ActivityState } from "./ActivityState";
import {
  ActivityStateFromJSON,
  ActivityStateFromJSONTyped,
  ActivityStateToJSON,
  ActivityStateToJSONTyped,
} from "./ActivityState";
import type { ActivityRole } from "./ActivityRole";
import {
  ActivityRoleFromJSON,
  ActivityRoleFromJSONTyped,
  ActivityRoleToJSON,
  ActivityRoleToJSONTyped,
} from "./ActivityRole";
import type { ActivityType } from "./ActivityType";
import {
  ActivityTypeFromJSON,
  ActivityTypeFromJSONTyped,
  ActivityTypeToJSON,
  ActivityTypeToJSONTyped,
} from "./ActivityType";

/**
 *
 * @export
 * @interface MutateActivityRequest
 */
export interface MutateActivityRequest {
  /**
   *
   * @type {string}
   * @memberof MutateActivityRequest
   */
  activityId?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof MutateActivityRequest
   */
  createdAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof MutateActivityRequest
   */
  createdBy?: string;
  /**
   *
   * @type {ActivityState}
   * @memberof MutateActivityRequest
   */
  state?: ActivityState;
  /**
   *
   * @type {ActivityType}
   * @memberof MutateActivityRequest
   */
  type: ActivityType;
  /**
   *
   * @type {string}
   * @memberof MutateActivityRequest
   */
  owner?: string;
  /**
   *
   * @type {ActivityRole}
   * @memberof MutateActivityRequest
   */
  trigger: ActivityRole;
  /**
   *
   * @type {ActivityRole}
   * @memberof MutateActivityRequest
   */
  target: ActivityRole;
  /**
   *
   * @type {string}
   * @memberof MutateActivityRequest
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof MutateActivityRequest
   */
  details?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof MutateActivityRequest
   */
  associatedDocuments?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof MutateActivityRequest
   */
  frontIds?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof MutateActivityRequest
   */
  metadata?: string;
  /**
   *
   * @type {string}
   * @memberof MutateActivityRequest
   */
  parentActivityId?: string;
  /**
   *
   * @type {string}
   * @memberof MutateActivityRequest
   */
  nextActivityId?: string;
  /**
   *
   * @type {Array<MutateActivityRequest>}
   * @memberof MutateActivityRequest
   */
  subActivities: Array<MutateActivityRequest>;
}

/**
 * Check if a given object implements the MutateActivityRequest interface.
 */
export function instanceOfMutateActivityRequest(
  value: object,
): value is MutateActivityRequest {
  if (!("type" in value) || value["type"] === undefined) return false;
  if (!("trigger" in value) || value["trigger"] === undefined) return false;
  if (!("target" in value) || value["target"] === undefined) return false;
  if (!("title" in value) || value["title"] === undefined) return false;
  if (!("subActivities" in value) || value["subActivities"] === undefined)
    return false;
  return true;
}

export function MutateActivityRequestFromJSON(
  json: any,
): MutateActivityRequest {
  return MutateActivityRequestFromJSONTyped(json, false);
}

export function MutateActivityRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): MutateActivityRequest {
  if (json == null) {
    return json;
  }
  return {
    activityId: json["activityId"] == null ? undefined : json["activityId"],
    createdAt: json["createdAt"] == null ? undefined : json["createdAt"],
    createdBy: json["createdBy"] == null ? undefined : json["createdBy"],
    state:
      json["state"] == null ? undefined : ActivityStateFromJSON(json["state"]),
    type: ActivityTypeFromJSON(json["type"]),
    owner: json["owner"] == null ? undefined : json["owner"],
    trigger: ActivityRoleFromJSON(json["trigger"]),
    target: ActivityRoleFromJSON(json["target"]),
    title: json["title"],
    details: json["details"] == null ? undefined : json["details"],
    associatedDocuments:
      json["associatedDocuments"] == null
        ? undefined
        : json["associatedDocuments"],
    frontIds: json["frontIds"] == null ? undefined : json["frontIds"],
    metadata: json["metadata"] == null ? undefined : json["metadata"],
    parentActivityId:
      json["parentActivityId"] == null ? undefined : json["parentActivityId"],
    nextActivityId:
      json["nextActivityId"] == null ? undefined : json["nextActivityId"],
    subActivities: (json["subActivities"] as Array<any>).map(
      MutateActivityRequestFromJSON,
    ),
  };
}

export function MutateActivityRequestToJSON(json: any): MutateActivityRequest {
  return MutateActivityRequestToJSONTyped(json, false);
}

export function MutateActivityRequestToJSONTyped(
  value?: MutateActivityRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    activityId: value["activityId"],
    createdAt: value["createdAt"],
    createdBy: value["createdBy"],
    state: ActivityStateToJSON(value["state"]),
    type: ActivityTypeToJSON(value["type"]),
    owner: value["owner"],
    trigger: ActivityRoleToJSON(value["trigger"]),
    target: ActivityRoleToJSON(value["target"]),
    title: value["title"],
    details: value["details"],
    associatedDocuments: value["associatedDocuments"],
    frontIds: value["frontIds"],
    metadata: value["metadata"],
    parentActivityId: value["parentActivityId"],
    nextActivityId: value["nextActivityId"],
    subActivities: (value["subActivities"] as Array<any>).map(
      MutateActivityRequestToJSON,
    ),
  };
}
